export const AVATAR_MAX_WIDTH = 120;
export const AVATAR_MAX_HEIGHT = 120;
// O avatar segue dentro do JSON em Base64, que cresce cerca de 33%.
// 65 KB mantém a requisição abaixo do limite do backend com os demais campos.
export const AVATAR_MAX_FILE_SIZE_BYTES = 65 * 1024;

export const validateAvatarFile = (file) => new Promise((resolve) => {
  if (!file || !String(file.type || '').startsWith('image/')) {
    resolve('Selecione um arquivo de imagem válido.');
    return;
  }

  if (file.size > AVATAR_MAX_FILE_SIZE_BYTES) {
    resolve('A imagem deve ter no máximo 65 KB e 120px × 120px. Reduza a imagem antes de enviar.');
    return;
  }

  const objectUrl = URL.createObjectURL(file);
  const image = new Image();
  image.onload = () => {
    URL.revokeObjectURL(objectUrl);
    if (image.naturalWidth > AVATAR_MAX_WIDTH || image.naturalHeight > AVATAR_MAX_HEIGHT) {
      resolve(
        `A imagem selecionada tem ${image.naturalWidth}px × ${image.naturalHeight}px. Use uma imagem de no máximo 120px × 120px.`,
      );
      return;
    }
    resolve('');
  };
  image.onerror = () => {
    URL.revokeObjectURL(objectUrl);
    resolve('Não foi possível ler a imagem. Escolha outro arquivo de até 120px × 120px.');
  };
  image.src = objectUrl;
});
